__turbopack_context__.v({
  "blok-big-title": "CollectionCardBlok-module__hGpXra__blok-big-title",
  "blok-subtitle": "CollectionCardBlok-module__hGpXra__blok-subtitle",
  "blok-title": "CollectionCardBlok-module__hGpXra__blok-title",
  "bold__tag": "CollectionCardBlok-module__hGpXra__bold__tag",
  "heading": "CollectionCardBlok-module__hGpXra__heading",
  "image": "CollectionCardBlok-module__hGpXra__image",
  "regular__tag": "CollectionCardBlok-module__hGpXra__regular__tag",
  "root": "CollectionCardBlok-module__hGpXra__root",
  "tags": "CollectionCardBlok-module__hGpXra__tags",
});
